/**
 * Ticket AD8: Hinweisseite, kein eigener Bereich. Keine Datenabfrage, keine
 * Schaltflächen – nur ein Wegweiser, damit der Menüpunkt nicht ins Leere zeigt.
 *
 * Entsteht hier der echte Bereich, muss die Kennzeichnung `muted: true` am
 * Eintrag „questionnaire-templates" in src/lib/admin-nav.ts entfernt werden,
 * sonst bleibt eine funktionierende Seite dauerhaft zurückgenommen dargestellt.
 */
import { createFileRoute, Link } from "@tanstack/react-router";
import { AdminPageHeader } from "@/components/admin/AdminPageHeader";

export const Route = createFileRoute("/_admin/admin/questionnaire-templates")({
  component: AdminQuestionnaireTemplatesPlaceholder,
});

function AdminQuestionnaireTemplatesPlaceholder() {
  return (
    <div className="space-y-6">
      <AdminPageHeader
        title="Fragebogen-Vorlagen"
        description="Künftig lassen sich Vorlagen hier anlegen, um Felder, Reihenfolge und Veröffentlichung selbst zu bearbeiten."
      />
      <p className="max-w-2xl text-sm text-muted-foreground">
        Die Vorlagen liegen bislang nur in der Datenbank, ihre Pflege läuft derzeit über die
        Agentur: Neue Fragebögen und Änderungen an Feldern geben Sie bitte dort auf. Die
        ausgefüllten Rückläufe Ihrer Kundinnen und Kunden finden Sie unabhängig davon schon heute
        unter{" "}
        <Link to="/admin/questionnaires" className="font-semibold underline">
          Fragebogen-Rückläufe
        </Link>
        .
      </p>
    </div>
  );
}
